import { m } from "@estate-platform/i18n/messages";
import { LinkButton } from "@estate-platform/ui/link-button";
import { TriangleAlert } from "lucide-react";
import { useEffect, useState } from "react";

import { StatusPage } from "./status-page.tsx";

import type { ErrorComponentProps } from "@tanstack/react-router";
import type { ReactElement } from "react";

const newReference = (): string =>
  `ERR-${crypto.getRandomValues(new Uint16Array(1))[0]?.toString(16).toUpperCase().padStart(4, "0") ?? "0000"}`;

// WHY: a full reload recovers from a failed chunk too, which an in-app retry cannot.
export const ErrorPage = ({ error }: ErrorComponentProps): ReactElement => {
  const [reference] = useState(newReference);
  useEffect(() => {
    reportError(new Error(reference, { cause: error }));
  }, [error, reference]);
  return (
    <StatusPage
      icon={TriangleAlert}
      title={m.error_load_title()}
      hint={m.error_reference({ reference })}
      action={<LinkButton href={location.href}>{m.action_try_again()}</LinkButton>}
    />
  );
};
